<app-dialog
  *ngIf="{ value: isAutoPayFormEnabled$ | async } as isAutoPayFormEnabled"
  [formGroup]="autoPayGroupV5"
  [size]="DialogSize.SMALL"
>
  <!-- Dialog Header -->
  <app-dialog-header>AutoPay for {{ data?.account?.name }}</app-dialog-header>

  <div *ngIf="didRequestError$ | async" class="alert alert--error mb-6 body-400">
    Attempt to save has failed, please try your request again later.
  </div>

  <!-- Active Recurring Payment Plan(s) Warning -->
  <div
    *ngIf="data.recurringPaymentPlans.length as recurringCount"
    class="alert deactivate-recurring-payments mb-6 body-400"
    [ngClass]="{ 'deactivate-recurring-payments-valid': deactivateRecurringPaymentsControl.value }"
  >
    AutoPay and Recurring Payments cannot be set up at the same time on the same client account.
    You currently have {{ recurringCount }} recurring payment plan{{ recurringCount > 1 ? 's' : '' }} set up for {{ data.account.name }}.
    Would you like to disable recurring payments for {{ data.account.name }}?

    <mat-checkbox
      [formControl]="deactivateRecurringPaymentsControl"
      class="align-items-start mt-2 group-500"
      data-cy="deactivate-recurring-payments-checkbox"
    >
      Yes, please disable existing recurring payments for {{ data.account.name }}.
    </mat-checkbox>
  </div>

  <!-- Select Monthly Payment Day -->
  <p class="h4-500 color-gray-100">Monthly payment day</p>
  <div class="d-flex align-items-center mt-2">
    <select [formControl]="dayControl" class="form-select w-fit-content me-2">
      <option *ngFor="let dayOption of dayOptions" [value]="dayOption.value">{{ dayOption.display }}</option>
    </select>
    <p class="body-400 color-gray-500">day of the month</p>
  </div>
  <mat-hint class="d-block small-300 color-gray-400 mt-2">
    Choose a day for monthly AutoPay. Invoices issued within {{ configService.autopayBufferDays }} days of this date
    will be scheduled for AutoPay the next month, ensuring time for review.
  </mat-hint>

  <!-- Specify Maximum Payment Amount -->
  <p class="h4-500 color-gray-100 mt-6">Maximum amount (optional)</p>
  <input
    [formControl]="maxAmountControl"
    currencyMask
    [options]="{ prefix: '', align: '', allowNegative: 'false'}"
    maxlength="12"
    placeholder="full amount"
    class="form-input form-input--amount text-end mt-2 auto-pay-max-amount-input"
  />
  <mat-hint class="d-block small-300 color-gray-400 mt-2">
    Set an optional monthly AutoPay limit. If the total due exceeds this limit, you'll need to cover the excess by the due date.
  </mat-hint>

  <!-- Select Payment Method -->
  <div *ngIf="data.didCreate && (savedPaymentMethodsExist$ | async) === false" class="mt-2 tc--warning body-400">
    A saved payment method is required to set up AutoPay. Please create one now.
  </div>
  <app-select-payment-method
    [intent]="PaymentMethodIntent.PAYMENT"
    [paymentFlow]="PaymentFlow.PLAN"
    [paymentMethodMode]="paymentMethodMode$ | async"
    [selectedPaymentMethodId]="selectedPaymentMethodId$ | async"
    [workflow]="PaymentsWorkflowType.AUTO_PAYMENT_PLAN"
    [surface]="'settings-autopay-dialog'"
    (paymentMethodModeChange)="paymentMethodMode$.next($event)"
    (paymentMethodSelected)="onSavedPaymentMethodSelected($event)"
    class="mt-6"
  ></app-select-payment-method>
  <div
    *ngIf="!data.didCreate && data.isEnabled && !authAdaptor.isAdmin && !(didUpdatePaymentMethod$ | async)"
    class="mt-2 alert body-400"
  >
    Please note that someone else set up AutoPay for {{ data.account.name }}.
    In order to make changes to AutoPay, you must first update the payment method.
    Note that you will not be able to revert back to the previous payment method once the payment method has been updated.
  </div>

  <!-- Specify Email Addresses for Payment Receipts -->
  <app-recipient-emails
    [disabled]="!isAutoPayFormEnabled.value"
    [primaryEmail]="primaryEmail"
    class="mt-6"
    (primaryEmailChanged)="onPrimaryEmailChanged($event)"
    (additionalEmailsChanged)="onAdditionalEmailsChanged($event)"
  ></app-recipient-emails>

  <!-- Dialog Footer -->
  <app-dialog-footer>
    <button andButton color="primary" type="submit" [isLoading]="isProcessingRequest$ | async" (click)="onSave()">Save</button>
  </app-dialog-footer>
</app-dialog>
